module.exports = __webpack_public_path__ + "img/ability-swiper2.23d9d535.png";